import { VanillaSettingsData, QuickBooksData, ShipStationData, DiagnosticData, } from './types';

export const buildVanillaSettingsPayload = (tenantId: string, vanillaData: VanillaSettingsData) => ({
  px_tenant_id: tenantId,
  px_config: {
    apiUser: vanillaData.saas.apiUser,
    baseUrl: vanillaData.saas.baseUrl,
    clientId: vanillaData.saas.clientId,
    apiUserPwd: vanillaData.saas.apiUserPassword,
    userPoolId: vanillaData.saas.userPoolId,
  },
  pxw_config: {
    apiUser: vanillaData.pxw.apiUser,
    baseUrl: vanillaData.pxw.baseUrl,
    clientId: vanillaData.pxw.clientId,
    apiUserPwd: vanillaData.pxw.apiUserPassword,
    userPoolId: vanillaData.pxw.userPoolId,
  },
  processType: 'PxwTenantVanillaSettingSetup',
  isScript: true,
});

export const buildQboConfiguratorPayload = (tenantId: string, qboData: QuickBooksData) => {
  const charges = qboData.purchaseOrderCharges
    .split(/[\n,]+/)
    .map((c) => c.trim())
    .filter(Boolean);

  return {
    px_tenant_id: tenantId,
    charges,
    qboClientDetails: {
      clientId: qboData.qboClientId,
      clientSecret: qboData.qboClientSecret,
    },
    qboApiSettings: {
      realmId: qboData.realmId,
      tokens: {
        id_token: '',
        expires_in: 3600,
        token_type: 'bearer',
        access_token: qboData.accessToken,
        refresh_token: qboData.refreshToken,
        x_refresh_token_expires_in: 8654383,
      },
    },
    processType: 'PxwTenantErpConfigQboConfigurator',
    isScript: true,
  };
};

export const buildQboSetupPayload = (tenantId: string, qboData: QuickBooksData) => ({
  px_tenant_id: tenantId,
  salesTaxEnabled: qboData.manuallyConfigureSalesTax,
  processType: 'PxwTenantQboSetup',
  isScript: true,
});

export const buildShipStationPayload = (tenantId: string, shipData: ShipStationData) => ({
  px_tenant_id: tenantId,
  shipStationStoreName: shipData.storeNumber || tenantId,
  shipStationWebhookUrl: shipData.webhookUrl,
  shipStationDetails: {
    v1ApiKey: shipData.v1ApiKey,
    secretKey: shipData.v1SecretKey,
    v2ProdKey: shipData.v2ProdKey,
  },
  processType: 'PxwTenantShipStationSetup',
  isScript: true,
});

export const buildDiagnosticPayload = (tenantId: string, diagData: DiagnosticData) => {
  const settings: Record<string, any> = {};

  if (diagData.enableMannapovIce) {
    settings.MANNAPOV_ICE = {
      bearer: diagData.mannapovIce.bearer,
      baseURL: diagData.mannapovIce.baseUrl,
      license: diagData.mannapovIce.license,
    };
  }

  if (diagData.enablePhoneCheck) {
    settings.PHONE_CHECK = {
      apiKey: diagData.phoneCheck.apiKey,
      username: diagData.phoneCheck.userName,
    };
  }

  return {
    px_tenant_id: tenantId,
    diagnosticToolSettings: settings,
    processType: 'PxwTenantProcessingSoftwareSetup',
    isScript: true,
  };
};
